export default __webpack_public_path__ + "2f912749335e00f847ddd7fdd483adbb.png";